<template>
    <input
        autocomplete="off"
        name="_token"
        type="hidden"
        :value="csrfToken"
    />
</template>

<script setup lang="ts">
import { CSRF_TOKEN_INJECTION_KEY } from '@/injection-keys';
import { inject } from 'vue';

const csrfToken = inject(CSRF_TOKEN_INJECTION_KEY);
</script>
